import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PostStockBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/**
 * Directly creates a stock row \u2014 admin correction path used by the per-product
 * stock management page. Does not record a stock_intake; the /receive endpoint
 * is the audited path for normal deliveries.
 */
export function usePostStock() {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: PostStockBody) => {
      const response = await api.post('/stock', { body })
      if (!response.success) throw new Error(response.error.message)
      return response.data
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['products'] })
      queryClient.invalidateQueries({ queryKey: ['product', data.stock.productId] })
    },
  })
}
